import { Link, useLocation } from 'react-router'

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import { Skeleton } from '@/components/ui/skeleton'
import { useCompany } from '@/contexts/company'
import useTranslator from '@/hooks/translation'

export const CompanyBreadcrumbs = () => {
  const location = useLocation()
  const { getTranslation } = useTranslator()

  const { company } = useCompany()
  const pathname = location.pathname

  const getPageLabel = (): string => {
    if (pathname.includes('/projects')) {
      return getTranslation('common.projects')
    }

    if (pathname.includes('/members')) {
      return getTranslation('members.text')
    }

    if (pathname.includes('/settings')) {
      return getTranslation('companies.settings')
    }

    return ''
  }

  const pageLabel = getPageLabel()

  if (!pageLabel) return null

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/companies">{getTranslation('common.companies')}</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />

        <BreadcrumbItem>
          {company ? company.name : <Skeleton className="h-4 w-24" />}
        </BreadcrumbItem>
        <BreadcrumbSeparator />

        <BreadcrumbItem>
          <BreadcrumbPage>{pageLabel}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  )
}
